module.exports = __webpack_public_path__ + "img/klattring2.1affc033.jpg";